<template>
  <section class="text-inputs">
    <section-title>TextInput Component</section-title>
    <form-wrap>
      <form-field-set>
        <text-input
          v-model="textInput"
          :direction="direction"
          label="Text Input"
          name="textInput1"
        />

        <text-input
          v-model="textInput"
          :direction="direction"
          :is-disabled="true"
          label="Text Input Disabled"
          name="textInput2"
        />

        <text-input
          :direction="direction"
          label="Text Input Placeholder"
          placeholder="This is a placeholder"
          name="textInputPlaceholder"
          value=""
        />

        <text-input
          v-model="textInput"
          :direction="direction"
          error="Räum dein Zimmer auf"
          label="Text Input Error"
          name="textInput3"
        />

        <text-input
          v-model="textInputEmail"
          :direction="direction"
          label="Text Input Email"
          name="textInput4"
          type="email"
        />

        <text-input
          v-model="textInputPassword"
          :direction="direction"
          label="Text Input Password"
          name="textInput5"
          type="password"
        />

        <text-input
          v-model="textInputTel"
          :direction="direction"
          label="Text Input Telefon"
          name="textInput6"
          type="tel"
        />

        <text-input
          :direction="direction"
          :is-copyable="true"
          :is-disabled="true"
          label="Text Input Copyable"
          name="textInput7"
          value="https://stateofjs.com/2017/introduction/"
        >
          <a
            slot="addon"
            target="_blank"
            href="https://stateofjs.com/2017/introduction/"
          >
            Open in new window
          </a>
        </text-input>

        <text-input
          v-model="textInput"
          :direction="direction"
          label="Text Input Suffix"
          name="textInput8"
          suffix="@foldaz.com"
        />

        <text-input
          :direction="direction"
          label="Text Input Prefix"
          name="textInput9"
          value="domain"
          prefix="support@"
        />

        <text-input
          :direction="direction"
          label="Text Input Pre- and Suffix"
          name="textInput10"
          prefix="Prefix"
          suffix="Suffix"
          value="and"
        />

        <text-input
          v-model="textInputDate"
          :direction="direction"
          :formatter-options="{ date: true, datePattern: ['d', 'm', 'Y'], delimiter: '.' }"
          label="Text Input Date"
          name="textInput11"
          placeholder="DD.MM.YYYY"
        />
      </form-field-set>
    </form-wrap>
  </section>
</template>

<script>
import PlaygroundCommmonMixin from '@/mixins/pages/playground/PlaygroundCommon'
import FormFieldSet from '@/components/forms/FormFieldSet'
import FormWrap from '@/components/forms/FormWrap'
import SectionTitle from '@/components/ui/SectionTitle'
import TextInput from '@/components/forms/TextInput'

export default {
  name: 'TextInputs',
  mixins: [PlaygroundCommmonMixin],
  components: {
    FormFieldSet,
    FormWrap,
    SectionTitle,
    TextInput
  },
  data () {
    return {
      textInput: 'Christian',
      textInputDate: '',
      textInputEmail: 'christian.gambardella@gmail.com',
      textInputPassword: 'secret',
      textInputTel: '015151022377'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/playground/TextInputs.vue